import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import H from "history";
import ApiService from '../../ApiService';
import DispatchProps from '../../../utils/DispatchProps';
import AnalyticsDateControls from '../../AnalyticsDateControls';
import { IRootState } from '../../../store';
import AcademicYearPicker from '../../AcademicYearPicker';
import SchoolMenu from '../../SchoolMenu';
import SchoolPageTitle from '../../SchoolPageTitle';
import AnalyticsControlBar from "../../assignment-analytics/AnalyticsControlBar";
import SchoolAnalyticsOverviewCharts from "../../assignment-analytics/SchoolAnalyticsOverviewCharts";
import { CommandButton } from "office-ui-fabric-react/lib-commonjs";
import { openFileDownload } from '../../../utils/Utils';

interface SchoolAnalyticsOverviewPageProps {
    tenantId: string;
    schoolCode: string
    history: H.History;
    apiService: ApiService;
    startDate?: string,
    endDate?: string,
    academicYear: number,
}

interface SchoolAnalyticsOverviewPageState {
}

class SchoolAnalyticsOverviewPage extends Component<SchoolAnalyticsOverviewPageProps & DispatchProps, SchoolAnalyticsOverviewPageState> {
    static displayName = SchoolAnalyticsOverviewPage.name;


    constructor(props: SchoolAnalyticsOverviewPageProps & DispatchProps) {
        super(props);
        this.state = {
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<SchoolAnalyticsOverviewPageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    
    private onAcademicYearChanged = (academicYear: number) => {
        if (this.props.academicYear !== academicYear) {
            AnalyticsDateControls.SetDateRangeToAcademic(this.props.history, academicYear);
        }
    }

    private async export() {
        if (this.props.startDate !== undefined && this.props.endDate !== undefined) {
            const result = await this.props.apiService.getCsvExport(this.props.tenantId, this.props.schoolCode, this.props.startDate, this.props.endDate, this.props.academicYear);
            openFileDownload(result);
        }
    }
    
    render() {
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title={`Assignment Analytics - Overview`} reverse={true} />
                <SchoolMenu prefix="Assignment Analytics" prefixLink={`/manage/${this.props.tenantId}/${this.props.schoolCode}/assignment-analytics-overview?academicYear=${this.props.academicYear}&startDate=${this.props.startDate}&endDate=${this.props.endDate}`} suffix="Overview" />
                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    <AnalyticsControlBar tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} current={"overview"} startDate={this.props.startDate} endDate={this.props.endDate} academicYear={this.props.academicYear} onAcademicYearChanged={this.onAcademicYearChanged} history={this.props.history} />
                    <SchoolAnalyticsOverviewCharts tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} startDate={this.props.startDate!} endDate={this.props.endDate!} academicYear={this.props.academicYear} onAcademicYearChanged={this.onAcademicYearChanged} apiService={this.props.apiService} history={this.props.history} />
                    <CommandButton className={"flex--align-self-flex-end m-right-1rem"} text="Export Assignments Data" onClick={() => this.export()} />
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): SchoolAnalyticsOverviewPageProps => {

        const { startDate, endDate } = AnalyticsDateControls.fromQueryStringOrDefault(ownProps.history.location.search);
        const academicYear = AcademicYearPicker.fromQueryStringOrDefault(ownProps.history.location.search);

        return {
            apiService: state.auth.apiService,
            history: ownProps.history,
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            startDate: startDate,
            endDate: endDate,
            academicYear: academicYear
        };
    }
)(SchoolAnalyticsOverviewPage)
